import { useEffect } from "react";

export function useClickOutside(ref, onOutsideClick, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const handler = (event) => {
      if (!ref.current) return;

      if (!ref.current.contains(event.target)) {
        onOutsideClick(event);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [ref, onOutsideClick, enabled]);
}
